import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { TableDetailsComponent } from './pages/table-details/table-details.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SelectPaymentComponent } from './pages/table-details/select-payment/select-payment.component';
import { AuthenticateComponent } from './pages/authenticate/authenticate.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { PaymentFinishedComponent } from './pages/payment-finished/payment-finished.component';
import { ShowReceiptsComponent } from './pages/show-receipts/show-receipts.component';
import { CartComponent } from './pages/store/cart/cart.component';
import { StoreMenuComponent } from './pages/store/menu/menu.component';
import { OrderSummaryPageComponent } from './pages/order-summary/order-summary.component';

export const routes: Routes = [
  {
    path: ':uuid',
    component: HomeComponent,
  },
  {
    path: ':uuid/details',
    component: TableDetailsComponent,
  },
  {
    path: ':uuid/conta',
    component: OrderSummaryPageComponent,
  },
  {
    path: ':uuid/details/payments',
    component: SelectPaymentComponent,
  },
  {
    path: ':uuid/details/authenticate',
    component: AuthenticateComponent,
  },
  {
    path: ':uuid/cardapio',
    component: StoreMenuComponent,
  },
  {
    path: ':uuid/pedido',
    component: CartComponent,
  },
  {
    path: ':uuid/payment',
    component: PaymentComponent,
  },
  {
    path: ':uuid/payment-finished',
    component: PaymentFinishedComponent,
  },
  {
    path: ':uuid/receipts',
    component: ShowReceiptsComponent,
  },
  {
    path: '**',
    component: NotFoundComponent
  },
];
